import src from "IMAGE";
export default { src, width: 895, height: 133, blurWidth: 0, blurHeight: 0};
